import React, { useEffect, useRef, useState } from 'react';
import { Button, LinkButton } from 'app/shared/button';
import { IconInput } from 'app/shared/input';
import { DetailItem } from 'app/shared/info-section/item';
import styles from './create.module.css';

const RESEND_COUNTDOWN = 60; // seconds a sent code stays valid before a resend

const formatCountdown = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};

export const VerifyPhoneModal = ({
  phone_number = '',
  confirming = false,
  resending = false,
  attemptsLeft = null,
  onConfirm = () => {},
  onResend = () => {}
}) => {
  const [code, setCode] = useState('');
  const [seconds, setSeconds] = useState(RESEND_COUNTDOWN);

  const code_is_valid = /^\d{4,8}$/.test(code);
  const expired = seconds <= 0;

  // Tick the countdown down to zero, once per second.
  useEffect(() => {
    if (seconds <= 0) return undefined;
    const timer = setInterval(() => setSeconds((s) => (s <= 0 ? 0 : s - 1)), 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  // Restart the countdown whenever a fresh code finishes sending.
  const was_resending = useRef(resending);
  useEffect(() => {
    if (was_resending.current && !resending) setSeconds(RESEND_COUNTDOWN);
    was_resending.current = resending;
  }, [resending]);

  return (
    <div className={styles.modalBody}>
      <p className={styles.modalText}>
        Enter the verification code we sent to <strong>{phone_number}</strong>.
      </p>

      <DetailItem title="Verification Code" required>
        <IconInput
          type="number"
          input_id="phone_code"
          className={styles.codeInput}
          value={code}
          placeholder="Enter code"
          onInput={(value) => setCode(value)}
          autoFocus
        />
      </DetailItem>

      {attemptsLeft != null && (
        <span className={styles.modalAttempts}>
          {attemptsLeft} {attemptsLeft === 1 ? 'attempt' : 'attempts'} left
        </span>
      )}

      <div className={styles.modalActions}>
        <div className={styles.modalResend}>
          {resending ? (
            <span>Resending…</span>
          ) : expired ? (
            <LinkButton className={styles.modalResendLink} text="Resend code" onClick={onResend} />
          ) : (
            <span>Resend code in {formatCountdown(seconds)}</span>
          )}
        </div>
        <Button
          className={styles.modalSubmit}
          text="Confirm code"
          loading={confirming}
          disabled={confirming || !code_is_valid}
          onClick={() => onConfirm(code)}
        />
      </div>
    </div>
  );
};
